export const BillInsuranceRulesFiles: React.FC = () => {
  return (
    <div className="gap-6">
      <ul className="my-4">
        <li>
          <a
            href="https://assets.vienasaskaita.lt/files/plans/Nelaimingu_atsitikimu_draudimo_sertifikato_pavyzdys_3943b25a34.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Nelaimingų atsitikimų draudimo sertifikato pavyzdys
          </a>
        </li>
        <li>
          <a
            href="https://assets.vienasaskaita.lt/files/plans/Nelaimingu_atsitikimu_draudimo_taisykles_6753871bd2.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Nelaimingų atsitikimų draudimo taisykles
          </a>
        </li>
        <li>
          <a
            href="https://assets.vienasaskaita.lt/files/plans/Nelaimingu_atsitikimu_draudimo_produkto_informacinis_dokumentas_3067cb24f3.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Nelaimingų atsitikimų draudimo produkto informacinis dokumentas
          </a>
        </li>
        <li>
          <a
            href="https://ergo.lt/teisine-informacija/privatumo-politika"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Draudiko privatumo politika
          </a>
        </li>
      </ul>
    </div>
  );
};
